import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'pro' | 'total'>('total');
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 25,
    s: 12
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Precios y planes" data-id="element-218">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-219">
        {/* Countdown Timer */}
        <FadeIn data-id="element-220">
          <div className="text-center mb-8" data-id="element-221">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-222">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-heading font-bold text-gold" data-id="element-223">
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-224">
                {formatTime(timeLeft.h)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-225">
                  hs
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-226">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-227">
                {formatTime(timeLeft.m)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-228">
                  min
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-229">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-230">
                {formatTime(timeLeft.s)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-231">
                  seg
                </span>
              </div>
            </div>
            <p className="text-red-400 mt-4 font-medium" data-id="element-232">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-233">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-234">
            ELEGÍ TU <span className="text-gold" data-id="element-235">PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-12" role="radiogroup" aria-label="Seleccionar plan" data-id="element-236">
          {/* Progress Bar */}
          <FadeIn delay={0.05} data-id="element-237">
            <div className="mb-6" data-id="element-238">
              <div className="flex justify-between text-sm mb-2" data-id="element-239">
                <span className="text-red-400 font-bold flex items-center gap-2" data-id="element-240">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-241"></span>
                  Cupos al precio de lanzamiento — Quedan pocos
                </span>
                <span className="text-gray-400" data-id="element-242">68%</span>
              </div>
              <div className="w-full bg-surfaceLight rounded-full h-2.5 overflow-hidden border border-white/5" data-id="element-243">
                <div className="bg-gold h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-244"></div>
              </div>
              <p className="text-xs text-gray-500 mt-2 text-center" data-id="element-245">
                68% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </FadeIn>

          {/* Pack 1 — Basic (anclaje de precio, arriba) */}
          <FadeIn delay={0.1} data-id="element-246">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} aria-label="Sistema Maestro de Aluminio — $17.990 ARS" className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-247">
              <div className="flex items-start gap-4" data-id="element-248">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-249">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-250"></div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-251">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-252">
                    <div data-id="element-253">
                      <h3 className="text-lg font-bold text-white flex items-center gap-2 mb-1" data-id="element-254">
                        <span data-id="element-255">📘</span> SISTEMA MAESTRO + 4 BONOS
                      </h3>
                      <p className="text-gray-400 text-xs mb-3" data-id="element-256">
                        Para arrancar con sistema · 6 Tomos + 4 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-257">
                        <span className="font-semibold text-white" data-id="element-258">
                          Resuelve:
                        </span>{' '}
                        Tablas, descuentos, protocolos y presupuestos.
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-259">
                      <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-260">
                        $45.000
                      </span>
                      <span className="text-2xl font-bold text-white font-heading" data-id="element-261">
                        $17.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-262">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pack 2 — Pro (DOMINANTE, en el medio — el más elegido) */}
          <FadeIn delay={0.2} data-id="element-263">
            <div id="pack-total" className="relative my-6 scroll-mt-24" data-id="element-264">
              {/* Glow exterior dorado para dominar visualmente */}
              <div className="absolute -inset-0.5 rounded-3xl opacity-70 blur-md pointer-events-none" aria-hidden="true" style={{
              background: 'linear-gradient(135deg, rgba(212,168,67,0.5) 0%, rgba(245,200,80,0.5) 100%)'
            }} data-id="element-265"></div>
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-266">
                <span className="bg-gold text-background font-bold px-5 py-1.5 rounded-full text-xs uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-267">
                  ⭐ EL MÁS ELEGIDO — TALLER AUTÓNOMO
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} aria-label="Sistema Maestro + Fichas de Taller — $23.990 ARS" className={`relative w-full text-left rounded-3xl p-7 md:p-8 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_35px_rgba(212,168,67,0.25)] bg-surfaceLight/80' : 'border-gold/40 bg-surfaceLight/50 hover:border-gold/70'}`} data-id="element-268">
                <div className="flex items-start gap-4" data-id="element-269">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-270">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-271"></div>}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-272">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-273">
                      <div data-id="element-274">
                        <h3 className="text-xl md:text-2xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-275">
                          <span data-id="element-276">🏆</span> SISTEMA MAESTRO + FICHAS DE TALLER
                        </h3>
                        <p className="text-gold text-sm md:text-base font-medium mb-3" data-id="element-277">
                          Sumá fichas de obra · Sistema Maestro + Fichas
                        </p>
                        <div className="bg-gold/10 px-3 py-2 rounded-lg border border-gold/30 text-xs text-gray-200 inline-block" data-id="element-278">
                          <span className="font-semibold text-white" data-id="element-279">
                            Resuelve:
                          </span>{' '}
                          Fichas listas para cada obra, menos errores del
                          operario.
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-280">
                        <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-281">
                          $55.000
                        </span>
                        <span className="text-4xl md:text-5xl font-bold text-gold font-heading" data-id="element-282">
                          $23.990
                        </span>
                        <span className="text-sm text-gold/70 ml-1" data-id="element-283">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* Pack 3 — Total (línea premium, abajo) */}
          <FadeIn delay={0.3} data-id="element-284">
            <div className="relative mb-6" data-id="element-285">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-286">
                <span className="bg-blue-500 text-white font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-287">
                  🔥 LA VERSIÓN MÁS COMPLETA 💎
                </span>
              </div>
              <button onClick={() => setSelectedPlan('total')} role="radio" aria-checked={selectedPlan === 'total'} aria-label="Sistema Maestro Pro — Todo Incluido — $29.990 ARS" className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400 ${selectedPlan === 'total' ? 'border-blue-400 shadow-[0_0_25px_rgba(59,130,246,0.2)] bg-surfaceLight/60' : 'border-blue-500/40 bg-background hover:border-blue-400/70'}`} data-id="element-288">
                <div className="flex items-start gap-4" data-id="element-289">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'total' ? 'border-blue-400' : 'border-gray-500'}`} data-id="element-290">
                    {selectedPlan === 'total' && <div className="w-2.5 h-2.5 rounded-full bg-blue-400" data-id="element-291"></div>}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-292">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-293">
                      <div data-id="element-294">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-295">
                          <span data-id="element-296">💎</span> SISTEMA MAESTRO PRO
                        </h3>
                        <p className="text-blue-300 text-sm font-medium mb-3" data-id="element-297">
                          Sistema Maestro + Fichas + A30 Master +{' '}
                          <span className="font-bold text-white bg-blue-500/20 px-1 rounded" data-id="element-298">
                            Módulo Técnico Premium
                          </span>
                        </p>

                        <div className="bg-blue-500/10 px-3 py-2 rounded-lg border border-blue-400/30 text-xs text-gray-200 inline-block mb-3" data-id="element-299">
                          <span className="font-semibold text-white" data-id="element-300">
                            Ideal para:
                          </span>{' '}
                          Talleres que quieren crecer, delegar mejor y entrar en
                          líneas premium con respaldo técnico real.
                        </div>

                        <div className="bg-surface/50 border border-blue-500/20 rounded-xl p-3" data-id="element-301">
                          <div className="flex items-center gap-2 mb-2" data-id="element-302">
                            <span className="bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-303">
                              Nuevo
                            </span>
                            <span className="font-bold text-white text-sm" data-id="element-304">
                              Módulo Técnico Premium Incluido:
                            </span>
                          </div>
                          <ul className="text-sm text-gray-300 space-y-1" data-id="element-305">
                            <li className="flex items-center gap-2" data-id="element-306">
                              <span className="text-blue-400" data-id="element-307">✓</span> HA62
                              (Línea Pesada)
                            </li>
                            <li className="flex items-center gap-2" data-id="element-308">
                              <span className="text-blue-400" data-id="element-309">✓</span> Rotonda
                              640
                            </li>
                            <li className="flex items-center gap-2" data-id="element-310">
                              <span className="text-blue-400" data-id="element-311">✓</span> Rotonda
                              750
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-312">
                        <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-313">
                          $85.000
                        </span>
                        <span className="text-3xl font-bold text-blue-300 font-heading" data-id="element-314">
                          $29.990
                        </span>
                        <span className="text-sm text-blue-300/70 ml-1" data-id="element-315">
                          ARS
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* CTA de compra — DEBAJO de la última opción */}
          <FadeIn delay={0.4} data-id="element-316">
            <a id="cta-comprar" href={selectedPlan === 'total' ? 'https://fegion.shop/cart/46934190555275:1' : selectedPlan === 'pro' ? 'https://fegion.shop/cart/46850730492043:1' : 'https://fegion.shop/cart/46850728263819:1'} className={`block w-full mt-6 py-5 text-center rounded-2xl font-bold transition-colors shadow-lg uppercase tracking-wider text-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'total' ? 'bg-blue-500 hover:bg-blue-600 text-white shadow-[0_0_25px_rgba(59,130,246,0.35)]' : 'bg-gold hover:bg-gold/90 text-background'}`} data-id="element-317">
              {selectedPlan === 'total' ? '→ QUIERO EL SISTEMA MAESTRO PRO — $29.990' : selectedPlan === 'pro' ? '→ QUIERO EL PACK PRO CON FICHAS' : '→ QUIERO EL PACK BASE AHORA'}
            </a>
          </FadeIn>

          {/* Trust strip debajo del CTA */}
          <FadeIn delay={0.45} data-id="element-318">
            <div className="mt-4 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-300" data-id="element-319">
              <div className="flex items-center gap-2" data-id="element-320">
                <span className="text-green-400" aria-hidden="true" data-id="element-321">
                  🛡️
                </span>
                <span data-id="element-322">Garantía 7 días</span>
              </div>
              <span className="text-white/20" aria-hidden="true" data-id="element-323">
                ·
              </span>
              <div className="flex items-center gap-2" data-id="element-324">
                <span className="text-green-400" aria-hidden="true" data-id="element-325">
                  ⚡
                </span>
                <span data-id="element-326">Acceso de inmediato</span>
              </div>
              <span className="text-white/20" aria-hidden="true" data-id="element-327">
                ·
              </span>
              <div className="flex items-center gap-2" data-id="element-328">
                <span className="text-green-400" aria-hidden="true" data-id="element-329">
                  🔒
                </span>
                <span data-id="element-330">Pago 100% seguro</span>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Comparison Table — Unificada (Fichas + A30 Master) */}
        <FadeIn delay={0.2} data-id="element-331">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-332">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-333">
              🔩 ¿QUÉ AGREGAN LAS <span className="text-gold" data-id="element-334">FICHAS</span> Y EL{' '}
              <span className="text-blue-400" data-id="element-335">SISTEMA MAESTRO PRO</span>?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-336">
              Mismo taller, tres realidades distintas según lo que tengas
              instalado
            </p>
            {(() => {
            const comparisonRows = [{
              situation: 'Trabajos en HA62 / Rotonda',
              noSystem: 'No los tomás',
              withFichas: 'Con dudas',
              withPro: 'Con respaldo técnico'
            }, {
              situation: 'Ayudante pide el descuento',
              noSystem: 'Buscás en el manual',
              withFichas: 'Tabla en la pared',
              withPro: 'Tabla A30/HA62 también'
            }, {
              situation: 'Presupuestás en la visita',
              noSystem: 'Adivinás el margen',
              withFichas: 'Calculador en mano',
              withPro: 'Margen real premium'
            }, {
              situation: 'Querés ofrecer líneas pesadas',
              noSystem: 'Miedo a perder plata',
              withFichas: 'Base para escalar',
              withPro: 'Sistema probado'
            }];
            return <>
                  {/* Desktop: tabla */}
                  <div className="hidden md:block" data-id="element-337">
                    <table className="w-full text-left border-collapse" data-id="element-338">
                      <thead data-id="element-339">
                        <tr data-id="element-340">
                          <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-341">
                            Situación en el taller
                          </th>
                          <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-342">
                            ❌ Sin sistema
                          </th>
                          <th className="p-4 border-b border-white/10 text-gold font-semibold bg-gold/5" data-id="element-343">
                            ✅ Con Fichas
                          </th>
                          <th className="p-4 border-b border-white/10 text-blue-400 font-semibold bg-blue-500/5 rounded-tr-xl" data-id="element-344">
                            💎 Sistema Maestro Pro
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-sm md:text-base" data-id="element-345">
                        {comparisonRows.map((row, i) => {
                      const isLast = i === comparisonRows.length - 1;
                      return <tr key={i} className={`${isLast ? '' : 'border-b border-white/5'} hover:bg-white/5 transition-colors`} data-id="element-346">
                              <td className={`p-4 text-gray-300 ${isLast ? 'rounded-bl-xl' : ''}`} data-id="element-347">
                                {row.situation}
                              </td>
                              <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-348">
                                {row.noSystem}
                              </td>
                              <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-349">
                                {row.withFichas}
                              </td>
                              <td className={`p-4 text-white bg-blue-500/5 font-medium ${isLast ? 'rounded-br-xl' : ''}`} data-id="element-350">
                                {row.withPro}
                              </td>
                            </tr>;
                    })}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile: cards compactas con 3 columnas */}
                  <div className="md:hidden space-y-3" data-id="element-351">
                    {/* Header chips para contextualizar las 3 columnas */}
                    <div className="grid grid-cols-3 gap-2 px-1" data-id="element-352">
                      <div className="text-center text-[10px] font-bold uppercase tracking-wider text-red-400" data-id="element-353">
                        ❌ Sin
                      </div>
                      <div className="text-center text-[10px] font-bold uppercase tracking-wider text-gold" data-id="element-354">
                        ✅ Fichas
                      </div>
                      <div className="text-center text-[10px] font-bold uppercase tracking-wider text-blue-400" data-id="element-355">
                        💎 Pro
                      </div>
                    </div>
                    {comparisonRows.map((row, i) => <div key={i} className="bg-surfaceLight/30 rounded-xl border border-white/10 p-3" data-id="element-356">
                        <p className="text-white font-semibold text-xs mb-2 text-center" data-id="element-357">
                          {row.situation}
                        </p>
                        <div className="grid grid-cols-3 gap-1.5" data-id="element-358">
                          <div className="bg-red-500/5 border border-red-500/15 rounded-lg p-2 text-center" data-id="element-359">
                            <span className="text-gray-300 text-[11px] leading-tight block" data-id="element-360">
                              {row.noSystem}
                            </span>
                          </div>
                          <div className="bg-gold/5 border border-gold/20 rounded-lg p-2 text-center" data-id="element-361">
                            <span className="text-white text-[11px] leading-tight block font-medium" data-id="element-362">
                              {row.withFichas}
                            </span>
                          </div>
                          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-2 text-center" data-id="element-363">
                            <span className="text-white text-[11px] leading-tight block font-medium" data-id="element-364">
                              {row.withPro}
                            </span>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </>;
          })()}
          </div>
        </FadeIn>

        {/* Includes — Tabla unificada lado a lado */}
        <FadeIn delay={0.3} data-id="element-365">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-366">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-367">
              ✅ ¿QUÉ INCLUYE CADA UNO?
            </h3>
            <p className="text-gray-400 text-center mb-8" data-id="element-368">
              Todo lo que entra dentro de cada componente extra
            </p>

            <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-369">
              {/* Sistema de Trabajo en 1 Minuto */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-7 border border-gold/20" data-id="element-370">
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gold/10" data-id="element-371">
                  <span className="text-3xl" aria-hidden="true" data-id="element-372">
                    🔩
                  </span>
                  <div data-id="element-373">
                    <h4 className="text-base md:text-lg font-bold text-gold leading-tight" data-id="element-374">
                      SISTEMA DE TRABAJO EN 1 MINUTO
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-375">
                      Incluido en Pack Pro y Pack Total
                    </p>
                  </div>
                </div>
                <ul className="space-y-2.5" data-id="element-376">
                  {['Tablas de descuento de bolsillo', 'Recetario de herrajes por tipología', 'Fichas de perfiles para armado', 'Planillas de corte imprimibles', 'Optimizador de barras anti-desperdicio', 'Calculador rápido de precio', 'Checklist de salida del taller', 'Hoja de ruta de producción'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-377">
                      <span className="text-gold mt-0.5 shrink-0" aria-hidden="true" data-id="element-378">
                        ✓
                      </span>
                      <span data-id="element-379">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* A30 Master */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-7 border border-blue-500/20" data-id="element-380">
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-blue-500/10" data-id="element-381">
                  <span className="text-3xl" aria-hidden="true" data-id="element-382">
                    💎
                  </span>
                  <div data-id="element-383">
                    <h4 className="text-base md:text-lg font-bold text-blue-400 leading-tight" data-id="element-384">
                      A30 MASTER + MÓDULO TÉCNICO PREMIUM
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-385">
                      Incluido solo en el Sistema Maestro Pro
                    </p>
                  </div>
                </div>
                <ul className="space-y-2.5" data-id="element-386">
                  {['Tablas de descuento para línea A30 / A40', 'Módulo HA62 (Línea Pesada)', 'Módulo Rotonda 640 y 750', 'Recetario de herrajes premium por tipología', 'Planos de mecanizados premium imprimibles', 'Protocolo de instalación alta prestación', 'Calculador de presupuesto con margen real', 'Checklist de entrega para trabajos premium'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-387">
                      <span className="text-blue-400 mt-0.5 shrink-0" aria-hidden="true" data-id="element-388">
                        ✓
                      </span>
                      <span data-id="element-389">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-390"></FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-391">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-392">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6 text-4xl" data-id="element-393">
              🛡️
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-394">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-4" data-id="element-395">
              Abrí los tomos. Revisá las tablas. Explorá el sistema completo.
            </p>
            <p className="text-gray-300 text-lg mb-6" data-id="element-396">
              Si el contenido entregado no coincide con lo que describimos en
              esta página, te devolvemos el{' '}
              <span className="text-white font-semibold" data-id="element-397">
                100% de tu dinero
              </span>{' '}
              dentro de los primeros 7 días.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-398">
              <div className="flex items-center justify-center gap-2" data-id="element-399">
                <span className="text-green-400" aria-hidden="true" data-id="element-400">
                  ✅
                </span>{' '}
                Devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-401">
                <span className="text-green-400" aria-hidden="true" data-id="element-402">
                  ✅
                </span>{' '}
                Sin formularios, sin drama
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-403">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-404">
          <div className="max-w-3xl mx-auto mt-12" data-id="element-405">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-406">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" role="list" data-id="element-407">
              {[{
              q: '¿Sirve si trabajo con líneas que no son Herrero ni Módena?',
              a: 'Los conceptos de descuento, armado e instalación aplican a cualquier línea del mercado. Las tablas de Herrero y Módena te dan la lógica que después adaptás a cualquier perfil similar.'
            }, {
              q: '¿Cómo recibo el material?',
              a: '100% digital. Apenas completás el pago recibís un email con acceso inmediato a todos los PDFs. Lo descargás en tu celular, tablet o computadora y lo tenés para siempre.'
            }, {
              q: '¿Puedo imprimirlo?',
              a: 'Sí. Todo el sistema está diseñado para imprimirse. Las tablas, fichas y checklists están pensados para estar plastificados en la pared del taller o en el maletín de obra.'
            }, {
              q: '¿Sirve si soy nuevo en la carpintería de aluminio?',
              a: 'Sí. Si estás empezando, es la forma más rápida de aprender bien desde el principio. Si ya tenés experiencia, vas a encontrar el sistema que te faltaba para trabajar con más velocidad y menos errores.'
            }, {
              q: '¿Tiene garantía real?',
              a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, escribinos y te devolvemos el 100% sin preguntas.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" role="listitem" data-id="element-408">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" aria-expanded={openFaq === i} aria-controls={`faq-answer-${i}`} data-id="element-409">
                    <span className="font-medium text-white pr-4" data-id="element-410">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-411" />
                  </button>
                  {openFaq === i && <div id={`faq-answer-${i}`} className="px-6 pb-4 text-gray-400" role="region" aria-label={faq.q} data-id="element-412">
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}